import { useEffect, useState } from "react";
import { Order, OrdersInterface } from "src/utils/interfaces/interfaces";

export const DynamicSort = (property: any) => {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a: any, b: any) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  };

  export const useDebounce = (value: string, delay: number): string =>{
    const [debouncedValue, setDebouncedValue] = useState(value);
  
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);
  
    return debouncedValue;
  }
  
  const filterKeys: Array<String> = ["containerNumber","customsCode","hsCode", "lock"];
  export const FilterOrders = (Orders: OrdersInterface, filterString: any) => {
    if (
      filterString === null ||
      filterString === undefined ||
      filterString === ""
    ) {
      return Orders;
    } else {
      return Orders.filter((order: Order) => {
        const anyMatchFound = filterKeys.map((key) => {
          if (
            String(order[key as keyof Order])
              .toLocaleLowerCase()
              .includes(filterString.toLocaleLowerCase())
          )
            return true;
          else return false;
        });
        if (anyMatchFound.some((match) => match === true)) return true;
        else return false;
      });
    }
  };